import React from "react";
import classnames from "classnames";

import ExchangeList from "./ExchangeList";
import SecuritySearchResult from "./SecuritySearchResult";

export default class SecuritySearchSelector extends React.Component {
	constructor() {
		super();
		this.focusSearchText = this.focusSearchText.bind(this);
		// this.handleExchangeSelect = this.handleExchangeSelect.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}
	componentDidMount() {
		this.focusSearchText();
	}
	componentDidUpdate() {
		this.focusSearchText();
	}
	focusSearchText() {
		if (this.props.focus) {
			this.refs.securitySearchText.focus();
			if (this.props.select) {
				this.refs.securitySearchText.select();
			}
		} else {
			this.refs.securitySearchText.blur();
		}
	}

	handleSearch(e) {
		this.props.onSecuritySearch(e.target.value);
	}
	render() {
		var classes = classnames({
			"securitySearchSelector": true,
			"focus": this.props.focus
		});
		let open = this.props.searchInProgress || this.props.showSearchResultDropDown || this.props.showExchangeSelectorDropDown;
		// console.log(this.props.securitySearchResult);
		return (
			<div className={classes} >
				<div className="input-group">
					<div className={classnames({ "input-group-btn": true, "open": open })} >
						<button type="button" className="btn btn-default" onClick={this.props.onDropDownToggle}>
							{this.props.exchange} <span className="caret"></span>
						</button>
						<ExchangeList showDropDown={this.props.showExchangeSelectorDropDown} onExchangeSelect={this.props.onExchangeSelect} />
						<SecuritySearchResult showDropDown={this.props.showSearchResultDropDown} results={this.props.securitySearchResult}
							showLoading={this.props.searchInProgress} error={this.props.searchError} onSelect={this.props.onSecuritySelect}/>
					</div>
					<div className="inner-addon right-addon">
						<span className="glyphicon glyphicon-search"></span>
						<input type="text" className="form-control" placeholder="SecuritySearchSelector" ref="securitySearchText"
							onChange={this.handleSearch}
							onClick={this.props.onSecurityFocus}
							defaultValue={this.props.security} />
					</div>
				</div>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/SecuritySearchSelector.jsx
 **/